import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import TicTacToe from '../games/tictactoe';
import { useDispatch } from 'react-redux';
import { setGame } from '../actions';

const useStyles = makeStyles(theme=>({
	container:{
		display:'flex',
		minHeight:'300px',
		minWidth:'300px',
		backgroundColor:theme.palette.background.default,
	}
}));

const GameContainer = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const onGame = (game) => dispatch(setGame(game));

	return (
		<div className={classes.container} >
			<TicTacToe onGame={onGame} />			
		</div>
	);
};

export { GameContainer };

